<pages-container
  [title]="'main.hubOverview'"
  [icon]="'people'"
  [showSearch]="true"
  [searchValue]="search()"
  [showFilter]="true"
  (onSearchSent)="handleSearch($event)">
  <div buttons>
    <button mat-raised-button
            class="mat-white-bg"
            (click)="downloadXLSX()">
      <span>{{ 'exportUserXLSX' | translate }}</span>
    </button>
  </div>

  <app-filter filter-content [page]="'hubOverview'" [filters]="filterData()"
              [filterFromDB]="userFiltersFromDB()" (chooseFilter)="chooseFilters($event)"></app-filter>

  <div main-content class="table-container " id="hubOverviewPage">
    <mat-table class="products-table"
               #table
               [dataSource]="hubParticipants()"
               matSort
               [matSortActive]="sort()"
               [matSortDirection]="direction()"
               (matSortChange)="sortData($event)"
               (scroll)="onScroll($event)">

      <ng-container matColumnDef="name">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
          {{ 'hubOverview.name' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let user" class="customWidthClass">
          <p class="text-truncate">{{ user.lastName + ' ' + user.firstName}}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="parish">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef>
          {{ 'hubOverview.parish' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let user"
        [matTooltip]="user?.organization?.join(',')" [matTooltipDisabled]="!user?.organization || !user?.organization?.length">
          <p class="text-truncate">{{ user?.organization?.join(',') }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="event_date">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'hubOverview.event_date' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let user"
        [matTooltip]="user?.events?.join(',')" [matTooltipDisabled]="!user?.events || !user?.events?.length">
          <p class="text-truncate">{{ user?.events?.join(', ') }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statistic">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef>
          {{ 'hubOverview.event_and_elearning' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let user">
          <p class="text-truncate">
            <span>
<!--              @if (user?.learningPathsParticipants?.[0]?.learningPath?.learningPathsEventsCount) {-->
<!--                {{user?.learningPathsParticipants?.[0]?.learningPath?.learningPathsEventsCount}}/-->
<!--              }-->
              {{ user?.eventsCount || 0}} | {{ user?.elearningParticipantsCount || 0}}
            </span>
          </p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nextTrainingYear">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header
        [matTooltip]="'hubOverview.nextTrainingYear_full' | translate">
          {{ 'hubOverview.nextTrainingYear' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let user">
          <p class="text-truncate">{{ user?.nextTrainingYear }}</p>
        </mat-cell>
      </ng-container>

      <ng-container cdkColumnDef="certificate">
        <mat-header-cell *cdkHeaderCellDef>{{'certificate.title' | translate}}</mat-header-cell>
        <mat-cell *cdkCellDef="let user">
          @if (user?.certificates?.length) {
            <a mat-icon-button
               [href]="user?.certificates[0].document?.name ? getCertificateDocumentUrl(user?.certificates[0].document?.name) : null"
               download target="_blank" rel="noopener noreferrer"
               [matTooltip]="'certificate.download_certificate' | translate"
               [aria-label]="'certificate.download_certificate' | translate"
               (click)="$event.stopPropagation()">
              <mat-icon style="color: green">download</mat-icon>
            </a>
          } @else {
            <mat-icon style="color: red; margin: 12px">close</mat-icon>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="task">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef>
          {{ 'hubOverview.task' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let user">
          @if (user?.frontUserTasks?.length) {
            @for (task of user?.frontUserTasks; track task.id) {
              <div class="text-truncate task">
                 @if (!task?.completedAt) {
                  <mat-icon class="no_started">highlight_off</mat-icon>
                 } @else {
                   @if (task?.completedAt && !task?.rejected) {
                     <mat-icon class="started">check_circle_outline</mat-icon>
                   }
                   @if (task?.completedAt && task?.rejected) {
                     <mat-icon class="rejected">highlight_off</mat-icon>
                   }
                 }
                {{ task?.task?.title }}
              </div>
            }
          }
        </mat-cell>
      </ng-container>

      @for (column of tableAdditionalFrontUserInfo(); track column.id) {
        <ng-container [matColumnDef]="'additional_' + column.id">

          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column.columnName ||  column.title}}
          </mat-header-cell>

          <mat-cell *matCellDef="let user">
            @if ((user?.frontUserInfo | hubColumn:column.id)) {
              <mat-icon class="active">check_circle_outline</mat-icon>
            }
            @if (!(user?.frontUserInfo | hubColumn:column.id)) {
              <mat-icon class="no_active">highlight_off</mat-icon>
            }
          </mat-cell>

        </ng-container>
      }


      <mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></mat-header-row>
      <mat-row *matRowDef="let user; columns: displayedColumns();"
               class="event-row"
               matRipple
      [routerLink]="'/pages/frontusers/detail'" [queryParams]="{id: user.id}">
      </mat-row>

    </mat-table>
    <mat-paginator [length]="pagination()?.total"
                   [pageIndex]="pageIndex()"
                   [pageSize]="perPage()"
                   [pageSizeOptions]="[25, 50, 100]"
                   (page)="handlePageEvent($event)">
    </mat-paginator>
  </div>
</pages-container>
